export default function Council2020Entries() {
    return (
        <table id="filetable">
        {/*Start Table*/}
        <tr>
          <th>Meeting Date</th>
          <th>Minutes</th>
          <th>Agenda</th>
        </tr>
        {/*Start File*/}
        <tr>
          <td>12-21-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-12-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>12-10-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-12-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>11-16-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-11-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-27-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-10-27-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-19-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-10-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-01-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-10-01-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>09-21-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-09-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>08-17-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-08-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>07-20-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-07-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>06-15-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-06-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>05-18-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-05-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>04-29-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-04-29-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>03-31-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-03-31-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>03-10-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-03-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>02-18-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-02-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>02-11-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-02-11-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>01-21-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-01-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>01-14-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-01-14-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>01-06-2020</td>
          <td>
            <a href="../docs/council/minutes/2020/2020-01-06-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>Unavailable</td>
        </tr>
        {/*End File*/}
      </table>
    )
}